import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-checking">
        <Loader2 className="w-8 h-8 text-gold-400 animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
